export const categoryLables = {
  sector: 'Sector / Subsector',
  industry: 'Industry / Subindustry',
};
